export enum DraftBomColumns {
    'itemAlt' = 'itemAlt',
    'partNumber' = 'partNumber',
    'supplier' = 'supplier',
    'name' = 'name',
    'qty' = 'qty',
    'uom' = 'uom',
    'detail' = 'detail',
    'delete' = 'delete'
}